import { configureStore } from "@reduxjs/toolkit";

import userReducer from "./Slices/userSlice";
import authSlice from "./Slices/AuthSlice";
import partnerSlice from "./Slices/partnerSlice";
import serviceSlice from "./Slices/serviceSlice";

export const store = configureStore({
  reducer: {
    user: userReducer,
    auth: authSlice,
    partner: partnerSlice,
    service: serviceSlice,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
